export default "__VITE_ASSET__0zEyZzp$__"